import PropTypes from "prop-types";

const PrimaryButton = ({ children, onClick, className = "", ...props }) => {
  return (
    <button
      onClick={onClick}
      className={`w-full text-white font-semibold py-3 px-6 rounded-xl transition-colors text-sm sm:text-base mb-6 ${className}`}
      style={{ backgroundColor: "#01793B" }}
      onMouseEnter={(e) => (e.target.style.backgroundColor = "#015c2e")}
      onMouseLeave={(e) => (e.target.style.backgroundColor = "#01793B")}
      {...props}
    >
      {children}
    </button>
  );
};

PrimaryButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default PrimaryButton;
